import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "../../components/motion";
import { SectionLabel } from "../../components/SectionLabel";

const CARDS = [
  {
    key: "products",
    letter: "A",
    title: "Products",
    to: "/products",
    img: "/images/ladybug2.jpg",
    shape: "arch",
    text: "Biological crop protection solutions, available now and in development: beneficial organisms, biopesticides and biodiversity-based tools.",
    tags: ["Biological control", "Biopesticides", "Pacific sourcing"],
  },
  {
    key: "consulting",
    letter: "B",
    title: "Consulting",
    to: "/consulting",
    img: "/images/bruno-field.jpg",
    shape: "circle",
    text: "Technical consultancy, applied R&D and extension, supporting projects from initial needs assessment through to field implementation.",
    tags: ["IPM strategy", "Field trials", "Extension"],
  },
];

export const Pillars = () => (
  <section data-testid="home-pillars" className="bg-mist py-24 sm:py-32">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <SectionLabel index="02" className="text-moss">Two ways we work</SectionLabel>
      <MaskLines
        lines={["Solutions you can apply,", "expertise you can lean on."]}
        className="mt-8 max-w-4xl font-display text-4xl font-normal leading-[1.02] tracking-[-0.02em] text-teal sm:text-5xl lg:text-6xl"
      />
      <div className="mt-16 grid gap-6 lg:grid-cols-2">
        {CARDS.map((c, i) => (
          <Reveal key={c.key} delay={i * 0.12}>
            <Link to={c.to} data-testid={`pillar-${c.key}`} className="group relative flex h-full flex-col overflow-hidden bg-paper p-6 transition-colors duration-500 hover:bg-teal sm:p-10">
              <div className="flex items-start justify-between">
                <span className="font-display text-7xl font-light text-teal/20 transition-colors duration-500 group-hover:text-mist/25 sm:text-8xl">{c.letter}</span>
                <span className="flex h-14 w-14 items-center justify-center rounded-full border border-teal/25 text-teal transition-[transform,background-color,color,border-color] duration-500 group-hover:rotate-45 group-hover:border-sage group-hover:bg-sage group-hover:text-teal-ink">
                  <ArrowUpRight className="h-5 w-5" />
                </span>
              </div>
              <div className="mt-8 grid items-end gap-8 sm:grid-cols-[1fr_13rem]">
                <div>
                  <h3 className="font-display text-5xl font-normal tracking-tight text-teal transition-colors duration-500 group-hover:text-mist sm:text-6xl">{c.title}</h3>
                  <p className="mt-5 max-w-md text-[15px] leading-relaxed text-teal-ink/80 transition-colors duration-500 group-hover:text-mist/85">{c.text}</p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {c.tags.map((t) => (
                      <span key={t} className="rounded-full border border-teal/20 px-3 py-1 text-xs text-teal transition-colors duration-500 group-hover:border-mist/30 group-hover:text-mist">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
                <div className={`relative aspect-square overflow-hidden ${c.shape === "arch" ? "arch aspect-[3/4]" : "rounded-full"}`}>
                  <img src={c.img} alt={c.title} className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
